import { FilterType } from "@studyportals/omnisearch-interfaces";
import { FilterMapper } from "@app/routing/mappers/FilterMapper";
import { DurationFilterValue } from "@studyportals/search-api-interface";
import { RouteLocation } from "vue-router";
import { IExtendedWithPortalTypeFilterValue } from "@app/routing/mappers/IExtendedWithPortalTypeFilterValue";
import { PortalType } from "@studyportals/domain-client";

export class DurationFilterMapper extends FilterMapper {
	public filterType: FilterType = FilterType.DURATION;
	public isMultiSelect = true;
	private static instance: DurationFilterMapper;

	protected values: IExtendedWithPortalTypeFilterValue[] = [
		{ id: DurationFilterValue.LESS_THAN_ONE_MONTH, virtualPath: 'less-than-1-month', name: 'Less than 1 month', portalTypes: [PortalType.SHORT], isNotIndexable: true },
		{ id: DurationFilterValue.ONE_TO_THREE_MONTHS, virtualPath: '1-to-3-months', name: '1 to 3 months', portalTypes: [PortalType.SHORT], isNotIndexable: true },
		{ id: DurationFilterValue.MORE_THAN_THREE_MONTHS, virtualPath: 'more-than-3-months', name: 'More than 3 months', portalTypes: [PortalType.SHORT], isNotIndexable: true },
		{ id: DurationFilterValue.LESS_THAN_ONE_YEAR, virtualPath: 'less-than-1-year', name: 'Less than 1 year', portalTypes: [PortalType.MASTER, PortalType.DISTANCE_LEARNING], isNotIndexable: true },
		{ id: DurationFilterValue.ONE_YEAR, virtualPath: '1-year', name: '1 year', portalTypes: [PortalType.BACHELOR, PortalType.MASTER, PortalType.PHD, PortalType.DISTANCE_LEARNING] },
		{ id: DurationFilterValue.ONE_AND_A_HALF_YEARS, virtualPath: '1-5-years', name: '1.5 years', portalTypes: [PortalType.MASTER, PortalType.DISTANCE_LEARNING], isNotIndexable: true },
		{ id: DurationFilterValue.LESS_THAN_TWO_YEARS, virtualPath: 'less-than-2-years', name: 'Less than 2 years', portalTypes: [PortalType.BACHELOR, PortalType.PHD], isNotIndexable: true },
		{ id: DurationFilterValue.TWO_YEARS, virtualPath: '2-years', name: '2 years', portalTypes: [PortalType.BACHELOR, PortalType.MASTER, PortalType.PHD, PortalType.DISTANCE_LEARNING] },
		{ id: DurationFilterValue.TWO_AND_A_HALF_YEARS, virtualPath: '2-5-years', name: '2.5 years', portalTypes: [PortalType.BACHELOR, PortalType.PHD, PortalType.DISTANCE_LEARNING], isNotIndexable: true },
		{ id: DurationFilterValue.THREE_YEARS, virtualPath: '3-years', name: '3 years', portalTypes: [PortalType.BACHELOR, PortalType.PHD, PortalType.DISTANCE_LEARNING] },
		{ id: DurationFilterValue.THREE_AND_A_HALF_YEARS, virtualPath: '3-5-years', name: '3.5 years', portalTypes: [PortalType.BACHELOR, PortalType.PHD, PortalType.DISTANCE_LEARNING], isNotIndexable: true },
		{ id: DurationFilterValue.FOUR_YEARS, virtualPath: '4-years', name: '4 years', portalTypes: [PortalType.BACHELOR, PortalType.PHD, PortalType.DISTANCE_LEARNING] },
		{ id: DurationFilterValue.MORE_THAN_TWO_YEARS, virtualPath: 'more-than-2-years', name: 'More than 2 years', portalTypes: [PortalType.MASTER], isNotIndexable: true },
		{ id: DurationFilterValue.MORE_THAN_FOUR_YEARS, virtualPath: 'more-than-4-years', name: 'More than 4 years', portalTypes: [PortalType.BACHELOR, PortalType.PHD, PortalType.DISTANCE_LEARNING], isNotIndexable: true },
	];

	public static getInstance(): DurationFilterMapper {
		if (!DurationFilterMapper.instance) {
			DurationFilterMapper.instance = new DurationFilterMapper();
		}
		return DurationFilterMapper.instance;
	}

	private constructor() {
		super();
	}

	protected override getFilterValuesFromRouteQuery(valueSet: Set<IExtendedWithPortalTypeFilterValue>, route: RouteLocation): Set<IExtendedWithPortalTypeFilterValue> {
		const queryValue = route.query?.[this.filterType];
		if(typeof queryValue === 'string'){

			// Split and validate [0, 500],[-1, 29] into [0,500] and [-1,29]
			// Simple comma split doesn't work due to commas inside brackets
			const ids = queryValue.match(/\[[\d\s,-]+]/g) ?? [];

			for(const id of ids){
				// Normalize by removing spaces for consistent matching
				const normalizedId = id.replace(/\s/g, '');
				const value = this.values.find((v) => v.id === normalizedId);
				if(value) valueSet.add(value);
			}
		}

		return valueSet;
	}
}
